export const setCacheHeaders = () => {
    // Set cache control headers for all fetch requests
    const originalFetch = window.fetch;
    window.fetch = function (url, options = {}) {
        options.headers = {
            ...options.headers,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        };
        return originalFetch(url, options);
    };
};

// Call this function in your app's entry point
export const initializeCacheControl = () => {
    setCacheHeaders();

    // Clear cache on page load
    if (window.caches) {
        caches.keys().then(cacheNames => {
            cacheNames.forEach(cacheName => {
                caches.delete(cacheName);
            });
        });
    }
}; 